import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  header: {
    marginBottom: spacing(3)
  },
  tablePaper: {
    border: '1px solid rgba(0, 0, 0, 0.12)'
  },
  gridHeader: {
    height: 60,
    borderBottom: '1px solid #E0E0E0'
  },
  tableHead: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.25
  },
  loadingAnimation: {
    margin: spacing(5, 0)
  },
  loadMoreBtn: {
    margin: spacing(5, 0)
  }
}))
